import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "ShoppingCart"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M8.73507 22.4999C9.53425 22.4999 10.1821 21.8284 10.1821 20.9999C10.1821 20.1715 9.53425 19.4999 8.73507 19.4999C7.93588 19.4999 7.28802 20.1715 7.28802 20.9999C7.28802 21.8284 7.93588 22.4999 8.73507 22.4999ZM18.8642 22.4999C19.6634 22.4999 20.3112 21.8284 20.3112 20.9999C20.3112 20.1715 19.6634 19.4999 18.8642 19.4999C18.065 19.4999 17.4171 20.1715 17.4171 20.9999C17.4171 21.8284 18.065 22.4999 18.8642 22.4999ZM5.71091 5.24991H21.7587C21.9816 5.24423 22.1947 5.34545 22.336 5.52424C22.4774 5.70303 22.5313 5.93941 22.4822 6.16491L21.0352 12.9149C20.9594 13.2638 20.6565 13.5086 20.3116 13.4999H7.2882L7.88149 16.4999H20.3116V17.9999H7.2882C6.93891 18.0072 6.63447 17.7548 6.56467 17.3999L3.80081 2.99991H1.5V1.49991H4.3941C4.74339 1.49261 5.04782 1.74507 5.11762 2.09991L5.71091 5.24991ZM7.01333 11.9999H19.7329L20.8544 6.74994H6.0004L7.01333 11.9999Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/ShoppingCart.vue"]]);
